module.exports = __webpack_public_path__ + "img/purpose_0.c3513ad9.png";